<abc-popup
  #milestoneAbcPopup
  [height]="'auto'"
  [width]="'500px'"
  [showCloseButton]="true"
  [showTitle]="true"
  (onHidden)="resetValues()"
>
  <div class="dx-card popup-card-paddings card-radius">
    <form action="post" (submit)="persistMeasureTask($event)">
      <abc-form #milestoneAbcForm id="form" [(formData)]="measureTask" [colCount]="1">
        <dxi-item [isRequired]="true">
          <dx-text-box
            [stylingMode]="'outlined'"
            [(value)]="measureTask.Label"
            [width]="'100%'"
            [labelMode]="'floating'"
            [label]="resources('Ubt-MeasureTask-Label')"
            [disabled]="!canManageMilestones"
          >
          </dx-text-box>
        </dxi-item>
        <dxi-item [isRequired]="true">
          <dx-select-box
            fxFill
            class="drop-down-style"
            valueExpr="Id"
            [(value)]="measureTask.Responsible"
            [displayExpr]="dataService.getResponsibleFullName"
            [dataSource]="dataService.cachedResponsiblesResponse"
            [label]="resources('Ubt-CreateMeasure-Responsible')"
            [labelMode]="'floating'"
            [acceptCustomValue]="true"
            [disabled]="!canManageMilestones"
            (keydown)="$event.preventDefault()"
          >
          </dx-select-box>
        </dxi-item>
        <dxi-item itemType="group" [colCount]="1" [cssClass]="'form-fields-row'">
          <dxi-item [isRequired]="true">
            <dx-date-box
              class="date-box-style"
              [stylingMode]="'outlined'"
              [(value)]="measureTask.EndDate"
              [displayFormat]="'dd.MM.yyyy'"
              [width]="'100%'"
              [labelMode]="'floating'"
              [label]="resources('Ubt-MeasureTask-Target-date')"
              [disabled]="milestoneTaskPopupService.IsRoleAuthorizedToUpdateDate(isUpdatingTask)"
            >
            </dx-date-box>
          </dxi-item>
        </dxi-item>
        <dxi-item itemType="group" [colCount]="2" [cssClass]="'form-fields-row'"> </dxi-item>

        <dxi-item itemType="group" [cssClass]="'form-buttons-container'">
          <dxi-item itemType="button" [cssClass]="'submit-button'" [buttonOptions]="submitButtonOptions"> </dxi-item>
          <dxi-item itemType="button" [cssClass]="'cancel-button'" [buttonOptions]="cancelButtonOptions"> </dxi-item>
        </dxi-item>
      </abc-form>
    </form>
  </div>
</abc-popup>
